import { render, staticRenderFns } from "./COAAddAllocationModal3.vue?vue&type=template&id=43cc9c9f&scoped=true&"
import script from "./COAAddAllocationModal3.vue?vue&type=script&lang=js&"
export * from "./COAAddAllocationModal3.vue?vue&type=script&lang=js&"
import style0 from "./COAAddAllocationModal3.vue?vue&type=style&index=0&id=43cc9c9f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cc9c9f",
  null
  
)

export default component.exports